<template>
  <a-layout class='s_bf'>
      <a-form ref='form' :model='search' :style="{'marginBottom':'25px'}" :onFinish='pageSearchChange' layout='inline'>
        <a-form-item label="礼品名称" name='name'>
          <a-input v-model:value="search.name" style="width:250px;margin-bottom: 15px;" placeholder="请输入关键词进行搜索" />
        </a-form-item>
        <a-form-item label="礼品类型" name='gift_type'>
          <a-select v-model:value="search.gift_type" :style="{width:'140px'}" placeholder="全部">
            <a-select-option value="">全部</a-select-option>
            <a-select-option :value="1">实物</a-select-option>
            <a-select-option :value="2">消费卡券</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="礼品价格" name='price_type'>
          <a-select v-model:value="search.price_type" :style="{width:'140px'}" placeholder="全部">
            <a-select-option value="">全部</a-select-option>
            <a-select-option :value="1">积分</a-select-option>
            <a-select-option :value="2">积分+现金</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="礼品分类" name='ex_gift_cate_id'>
          <a-cascader :options="loadData" v-model:value="search.ex_gift_cate_id"
            :field-names="{ label: 'name', value: 'id', children: 'child' }" placeholder="请选择礼品分类" allowClear/>
        </a-form-item>
        <a-form-item label="礼品来源" name='product_type' v-if='search.gift_type == 1'>
          <a-select v-model:value="search.product_type" :style="{width:'140px'}" placeholder="全部">
            <a-select-option value="">全部</a-select-option>
            <a-select-option :value="1">自有礼品</a-select-option>
            <a-select-option :value="2">产品库</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item name="">
          <a-checkbox-group v-model:value="checkbox" name="checkbox" :options="options" />
          <a-button type="primary" htmlType='submit' class="m-r-20">搜索</a-button>
          <a-button @click='reset' class="m-r-20">重置</a-button>
          <a-button @click="()=> {$router.push('/integralShop/giftExchange/giftCreate?type=gift')}">
            新建礼品兑换
          </a-button>
        </a-form-item>
      </a-form>
      <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='data'>
        <template v-slot:info="{ record }">
          <a-card-meta>
            <template #avatar>
              <img :src="info.picdomain+record.image" alt="" style="width:50px;height: 50px;object-fit:cover">
            </template>
            <template #description>{{record.name}}</template>
          </a-card-meta>
        </template>
        <template v-slot:price="{ record }">
          <span v-if='record.price_type == 2'>{{record.price}}元+</span>
          <span class="m-r-5">{{record.point}}积分</span>
        </template>
        <template v-slot:use_exchange_num="{ record }">
          <p v-if="record.use_exchange_type==1 || record.use_exchange_type==3">每人{{record.use_exchange_num_json.date_type == 2 ?'每月':''}}限兑{{record.use_exchange_num_json.number}}件</p>
          <p v-if="record.use_exchange_type==0 || record.use_exchange_type==2">不限</p>
          <span class="m-r-5 s_c999">库存：{{record.use_exchange_num}}</span>
        </template>
        <template v-slot:action="{ record }">
          <a-button type="primary" @click='choose(record)' :ghost="!record.select" v-if='!checkout'>选择</a-button>
          <a-button type="primary" @click='choose(record)' :ghost="!record.select" v-else>选择</a-button>
        </template>
      </a-table>
      <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper
        :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange"
        @showSizeChange="pageSizeChange" />
      <div class="s_flex_center m-t-25" v-if='checkout'>
        <a-button type="primary" @click='confirm'>确定</a-button>
      </div>
  </a-layout>
</template>
<script>
  import { ref, onMounted, inject, reactive, toRefs } from "vue";
  import { message } from "ant-design-vue";
  import { useTree } from '@/hooks/useTree.js'
  import {
    exchangeGift,
    getCategory
  } from "@/api/integralShop";
  import { iscode } from "@/utils/app";
  import store from "@/store";
  // 初始化默认筛选项数值
  let defSearch = {
    name: "",
    stock_num: "",
    page: 1,
    limit: 5,
    gift_type: "",
    price_type: "",
    ex_gift_cate_id: "",
    product_type: "",
    is_timing_status: "",
    is_sale_all: "",
    is_time_out: "",
  };
  var options = [
    
    {
      label: '已抢光',
      value: 'is_sale_all',
    },
    {
      label: '已设置兑换权限',
      value: 'is_use_exchange',
    },
    {
      label: '已过期',
      value: 'is_time_out',
    },
  ]
  export default {
    name: "selectGift",
    props: {
      checkout: Boolean,
      selectList: {
        type: Array
      },
    },
    setup(props, { emit }) {
      // // 初始化 分页信息和筛选项信息
      let search = ref();
      search.value = { ...defSearch }
      // 列表数据和列头配置
      let data = ref([]);
      const state = reactive({
        info: store.state.user.info,
        checkbox: [],
        listLoading: false,
        time: [],
        total: 1,
        loadData: [],
        status: 1,
        selectList: [],//被选中的列表
      });
      let columns = [
        {
          title: "礼品信息",
          dataIndex: "info",
          key: "info",
          slots: { customRender: "info" }
        },
        {
          title: "礼品类型",
          dataIndex: "gift_type_name",
          key: "gift_type_name"
        },
        {
          title: "分类",
          dataIndex: "category_name",
          key: "category_name"
        },
        {
          title: "兑换价格",
          dataIndex: "price",
          key: "price",
          slots: { customRender: "price" }
        },
        {
          title: "库存",
          dataIndex: "use_exchange_num",
          key: "use_exchange_num",
          slots: { customRender: "use_exchange_num" },
        },
        {
          title: "操作",
          key: "action",
          slots: { customRender: "action" },
        },
      ];
      // 页面筛选项搜索
      const pageSearchChange = () => {
        search.value = { ...search.value, page: 1 };
        initData(search.value);
      };
      // 分页当前页切换
      const pageCurrentChange = (page, pageSize) => {
        search.value.page = page;
        initData(search.value);
      };
      // 分页当前页显示多少条切换
      const pageSizeChange = (current, limit) => {
        search.value.page = 1;
        search.value.limit = limit;
        initData(search.value);
      };
      // 获取分类
      const initCate = async () => {
        let result = await getCategory().then((res) => res.data);
        state.loadData = useTree(result.data);
        state.loadData.map((v) => (v.disabled = v.child.length == 0 ? true : false));
      };
      const form = ref();
      const reset = () => {
        search.value = defSearch
        form.value.resetFields()
        state.checkbox = []
        search.value.ex_gift_cate_id = ""
      };
      const initData = async (values) => {
        var json = JSON.parse(JSON.stringify(search.value))
        for (var i = 0; i < state.checkbox.length; i++) {
          json[state.checkbox[i]] = 1
        }
        state.listLoading = true;
        let res = await exchangeGift({ ...json, status: 1,ex_gift_cate_id:search.value.ex_gift_cate_id[1] }).then((res) => res.data);
        state.listLoading = false;
        if (iscode(res)) {
          data.value = res.data.data;
          state.total = res.data.total;
          if (state.selectList.length > 0) {
            data.value.forEach(i => {
              if (state.selectList.find(v => i.uniqid == v.uniqid)) {
                i.select = true
              }
            })
          }
        } else {
          message.error(res.msg);
        }
      };

      //单选
      const select = (e) => {
        e.select = !e.select
        emit("select", e);
      }
      //多选
      const checkBnt = (e) => {
        if (!e.select) {
          state.selectList.push(e);
        } else {
          var index = 0;
          state.selectList.forEach((v, k) => {
            if (v.uniqid == e.uniqid) {
              index = k;
            }
          });
          state.selectList.splice(index, 1);
        }
        e.select = !e.select
      }
      //多选确认
      const confirm = () => {
        emit("select", state.selectList);
      }
      const choose = (e) => {
        if (props.checkout) {
          checkBnt(e)
        } else {
          select(e)
        }
      }
      onMounted(() => {
        if(props.selectList){
          state.selectList = JSON.parse(JSON.stringify(props.selectList))
        }
        initData(search.value);
        initCate();
      });
      return {
        ...toRefs(state),
        search,
        data,
        columns,
        confirm,
        pageSearchChange,
        pageCurrentChange,
        pageSizeChange,
        reset,
        form,
        choose
      };
    },
  };
</script>